import { render, staticRenderFns } from "./CommonAside.vue?vue&type=template&id=50698670&scoped=true"
import script from "./CommonAside.vue?vue&type=script&lang=js"
export * from "./CommonAside.vue?vue&type=script&lang=js"
import style0 from "./CommonAside.vue?vue&type=style&index=0&id=50698670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50698670",
  null
  
)

export default component.exports